import AdditionalHeaderCamp from './AdditionalHeaderCamp';

export default AdditionalHeaderCamp;
